import React, { useRef, useState } from "react";
import styles from "./LoginPane.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../store/auth-actions";
import Button from "../../UI/Buttons/Button/Button";
import { authActions } from "../../../store/auth-slice";
import { RootState } from "../../../store";
import GoogleAuth from "../../GoogleAuth/GoogleAuth";

const LoginPane = () => {
  const dispatch = useDispatch();

  const usernameInputRef = useRef<HTMLInputElement>(null);
  const passwordInputRef = useRef<HTMLInputElement>(null);
  const [enteredUsernameIsValid, setEnteredUsernameIsValid] = useState(true);
  const [enterPasswordIsValid, setEnterPasswordIsValid] = useState(true);
  // Add password visibility state
  const [showPassword, setShowPassword] = useState(false);

  const loginFailed = useSelector((state: RootState) => state.auth.loginError);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    const credentials = {
      email: usernameInputRef.current!.value,
      password: passwordInputRef.current!.value,
    };

    if (credentials.email.trim() === "") {
      setEnteredUsernameIsValid(false);
      if (credentials.password.trim() === "") {
        setEnterPasswordIsValid(false);
      } else {
        setEnterPasswordIsValid(true);
      }
      return;
    }
    if (credentials.password.trim() === "") {
      setEnteredUsernameIsValid(true);
      setEnterPasswordIsValid(false);
      return;
    }

    setEnteredUsernameIsValid(true);
    setEnterPasswordIsValid(true);
    dispatch<any>(login(credentials));
  };

  const resetLoginStatus = () => dispatch(authActions.loginStatusReset());

  return (
    <div className={styles.loginPageWrap}>
      <div className={styles.imageWrap}>
        <img
          src="/temp-login-image.png"
          srcSet="/temp-login-image.png 480w, /temp-login-image.png 1200w"
          sizes="(max-width: 600px) 480px, (min-width: 601px) 1200px"
          alt="cover"
        />
      </div>
      <div className={styles.formWrap}>
        <form onSubmit={submitHandler} className={styles.LoginForm}>
          <h2 className={styles.header}>Prijavi se</h2>
          <div className={styles.subHeader}>
            Dobrodošli! Unesite svoje kredencijale.
          </div>

          {/* Username field - unchanged */}
          <div className={styles.InputFiledWrapper}>
            <input
              className={styles.InputFiled}
              ref={usernameInputRef}
              type="text"
              id="username"
              placeholder="Email"
              autoComplete="off"
              onFocus={resetLoginStatus}
            />
            <div className={styles.ValidationMessage}>
              {!enteredUsernameIsValid && "Ovo polje ne može biti prazno"}
            </div>
          </div>

          {/* Password field with toggle */}
          <div className={styles.InputFiledWrapper}>
            <div className={styles.PasswordInputContainer}>
              <input
                className={styles.InputFiled}
                ref={passwordInputRef}
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Lozinka"
                autoComplete="off"
                onFocus={resetLoginStatus}
              />
              <button
                type="button"
                className={styles.PasswordToggle}
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
                title={showPassword ? "Sakrij lozinku" : "Prikaži lozinku"}
              >
                👁
              </button>
            </div>
            <div className={styles.ValidationMessage}>
              {!enterPasswordIsValid && "Ovo polje ne može biti prazno"}
            </div>
          </div>

          <div
            className={styles.ValidationMessage}
            style={{ textAlign: "center", width: "fit-content" }}
          >
            {loginFailed && "Korisničko ime ili lozinka nisu ispravni"}
          </div>
          <Button buttonType="blue">Prijavi se</Button>

          <div className={styles.googleLoginWrap}>
            <GoogleAuth />
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPane;
